import { render } from "./autoComplete.vue?vue&type=template&id=1c682752"
import script from "./autoComplete.vue?vue&type=script&lang=js"
export * from "./autoComplete.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\tink\\tink-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__